
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { TouristTourFromDB } from "@/hooks/useTouristTours";
import { PackageData } from "@/pages/CreatePackage";

type TourForPackage = PackageData['tours'][0];

interface AddTourDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onAddTour: (tour: TourForPackage) => void;
  tourTemplate: TouristTourFromDB | null;
}

export const AddTourDialog = ({ isOpen, onOpenChange, onAddTour, tourTemplate }: AddTourDialogProps) => {
  const [date, setDate] = useState("");
  const [duration, setDuration] = useState("");
  const [included, setIncluded] = useState("");

  useEffect(() => {
    if (tourTemplate) {
      setDate("");
      setDuration("");
      setIncluded("");
    }
  }, [tourTemplate]);

  const handleAdd = () => {
    if (!tourTemplate || !date) return;

    const newTour: TourForPackage = {
      name: tourTemplate.name_ar,
      description: tourTemplate.description_ar || "",
      price: tourTemplate.price || 0,
      date,
      duration,
      included: included.split('\n').filter(i => i.trim() !== ""),
    };
    onAddTour(newTour);
    onOpenChange(false);
  };

  if (!tourTemplate) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent dir="rtl">
        <DialogHeader>
          <DialogTitle>إضافة جولة: {tourTemplate.name_ar}</DialogTitle>
          <DialogDescription>
            أدخل تفاصيل الجولة لإضافتها إلى البرنامج السياحي.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div>
            <Label htmlFor="tour-date">تاريخ الجولة</Label>
            <Input id="tour-date" type="date" value={date} onChange={e => setDate(e.target.value)} />
          </div>
          <div>
            <Label htmlFor="tour-duration">مدة الجولة (مثال: 3 ساعات)</Label>
            <Input id="tour-duration" value={duration} onChange={e => setDuration(e.target.value)} placeholder="مثال: يوم كامل" />
          </div>
          <div>
            <Label htmlFor="tour-included">البرنامج يشمل (بند واحد في كل سطر)</Label>
            <Textarea id="tour-included" value={included} onChange={e => setIncluded(e.target.value)} placeholder="تذكرة دخول&#x0a;مرشد سياحي" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>إلغاء</Button>
          <Button onClick={handleAdd}>إضافة الجولة</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
